<template>
  <q-scroll-area class="column col-grow">
    <q-list class="q-pa-md full-width">
      <q-item clickable v-for="sample in samples" :key="sample.id">
        <section class="row no-wrap items-center full-width justify-between">
          <div class="column">
            <span class="text-bold">{{ sample.detail.name }}</span>
            <span class="text-caption text-grey">
              {{ sample.detail.sample_id }}
            </span>
          </div>

          <div class="column items-center no-wrap">
            <span
              class="row items-center"
              :style="{ color: SAMPLE_STATUS_DICT[sample.sample_status].color }"
            >
              <q-icon
                :name="iconSet[sample.sample_status]"
                size="12px"
                class="q-mr-sm"
              ></q-icon>
              <span>{{  SAMPLE_STATUS_DICT[sample.sample_status].description  }}</span>
            </span>

            <span class="text-grey text-caption">
              {{ ((sample.process || 0) * 100).toFixed(1) }} %
            </span>
          </div>
        </section>
      </q-item>
    </q-list>
  </q-scroll-area>
</template>

<script>
import { SAMPLE_STATUS_DICT } from "../../../../../../shared/constants/sample-status";
export default {
  props: {
    samples: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      iconSet: {
        "0": "fas fa-check-circle",
        "1": "far fa-circle",
        "2": "fas fa-adjust",
        "3": "far fa-times-circle",
        "4": "far fa-times-circle",
      },
      SAMPLE_STATUS_DICT,
    };
  },
};
</script>
